class DesktopStickyAtcDisclosure extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", (e) => {
      if (!e.target.closest(".desktop-sticky-atc__disclosure-summary")) return;

      e.preventDefault();

      this._getElements();

      if (this.details.open) {
        this._close();
      } else {
        this._open();
      }
    });

    this.handleEvent = (e) => {
      if (!e.detail.sticking) {
        this._forceClosed();
      }
    };

    document.addEventListener("atc-bar-sticking", this.handleEvent);

    this.lastWasMobile = this._isMobile;

    this.handleResize = () => {
      if (!this.lastWasMobile && this._isMobile) {
        this._forceClosed();
      }

      this.lastWasMobile = this._isMobile;
    };

    window.addEventListener("resize", this.handleResize);

    this.addEventListener("focusout", (e) => {
      console.log("e.relatedTarget", e.relatedTarget);
      if (this.contains(e.relatedTarget)) return;
      this._close();
    });

    this.handleKeyUp = (e) => {
      if (this.details?.open && e.code.toUpperCase() === "ESCAPE") {
        this._close();
      }
    };

    document.addEventListener("keyup", this.handleKeyUp);
  }

  disconnectedCallback() {
    document.removeEventListener("atc-bar-sticking", this.handleEvent);
    document.removeEventListener("keyup", this.handleKeyUp);
    window.removeEventListener("resize", this.handleResize);
  }

  _forceClosed() {
    this._getElements();
    this.removeEventListener("transitionend", this.handleTransitionEnd);
    window.closeDimmer(this);
    this.details.open = false;
    this.content.style.height = null;
    this.content.style.opacity = null;
  }

  _open() {
    if (this.details.open) return;

    this.removeEventListener("transitionend", this.handleTransitionEnd);

    this.details.open = true;
    window.openDimmer(this);

    if (this.content) {
      this.content.style.height = 0;
      this.content.style.opacity = 0;

      window.requestAnimationFrame(() => {
        this.content.style.height = `${this.content.scrollHeight}px`;
        this.content.style.opacity = 1;
      });
    }
  }

  _close() {
    if (!this.details.open) return;

    window.closeDimmer(this);

    if (this.content) {
      this.removeEventListener("transitionend", this.handleTransitionEnd);

      this.handleTransitionEnd = () => {
        this.removeEventListener("transitionend", this.handleTransitionEnd);
        this.details.open = false;
      };

      this.addEventListener("transitionend", this.handleTransitionEnd);

      this.content.style.height = 0;
      this.content.style.opacity = 0;
    } else {
      this.details.open = false;
    }
  }

  _getElements() {
    this.details = this._details;
    this.content = this._content;
  }

  get _details() {
    return this.querySelector("details");
  }

  get _content() {
    return this.querySelector("[data-content]");
  }

  get _isMobile() {
    return window.matchMedia("(max-width: 1023px)").matches;
  }
}

if (!customElements.get("desktop-sticky-atc-disclosure")) {
  customElements.define(
    "desktop-sticky-atc-disclosure",
    DesktopStickyAtcDisclosure
  );
}
